<template>
    <div>

        <div class="redraw_block" v-if="!is_set_data">

            <info_field f_uniq="ct3"
                        f_type="group_name"
                        :is_disabled="true"
                        :f_title="__t('ROLE.TG_UID')"
                        :f_val="cur_item.user_uid">
            </info_field>

            <info_field f_uniq="ct3"
                        f_type="username_tg"
                        :is_disabled="true"
                        :f_title="__t('ROLE.TG_USERNAME')"
                        :f_val="'@' + cur_item.tg_user.username">
            </info_field>

            <info_field f_uniq="ct3"
                        f_type="username_tg_alias"
                        :is_disabled="false"
                        @input="val => change_atr('alias_name', val)"
                        :f_title="__t('ROLE.TG_ALIAS_NAME')"
                        :f_val="cur_item.tg_user.alias_name || ''">
            </info_field>

            <info_field f_uniq="ct3"
                        f_type="real_name"
                        :is_disabled="true"
                        :f_title="__t('ROLE.NAME')"
                        :f_val="cur_item.tg_user.first_name + ' ' + cur_item.tg_user.last_name">
            </info_field>

            <info_field f_uniq="ct3"
                        f_type="created_at"
                        :is_disabled="true"
                        :f_title="__t('ROLE.TG_ADDED')"
                        :f_val="cur_item.tg_user.created_at">
            </info_field>


            <div class="allow_in" >
                <b-row>
                    <b-col>
                        <div>
                            <yes_no key="IS_LOCKED" title="IS_LOCKED"
                                    @input="val => change_atr('is_locked', val)"
                                    v-model="cur_item.is_locked"
                            >
                            </yes_no>
                        </div>
                    </b-col>

                    <b-col>
                        <div>
                            <yes_no key="OPERATE_LOCATION_STATUS" title="OPERATE_LOCATION_STATUS"
                                    @input="val => change_atr('is_operate_location_status', val)"
                                    v-model="cur_item.is_operate_location_status"
                            >
                            </yes_no>
                        </div>
                    </b-col>

                    <b-col>
                        <div>
                            <yes_no key="OPERATE_ORDER_STATUS" title="OPERATE_ORDER_STATUS"
                                    @input="val => change_atr('is_operate_order_status', val)"
                                    v-model="cur_item.is_operate_order_status"
                            >
                            </yes_no>
                        </div>
                    </b-col>

                </b-row>
            </div>

        </div>

        <div class="mt-4" v-if="notification_groups.length">

            <h5 class="fw-700 mb-3">
                {{ __t('ROLE.NOTIFICATIONS') }}
            </h5>

            <b-tabs pills card vertical>
                <b-tab
                    v-for="(items, groupType, index) in groupedNotificationGroups"
                    :key="'notif_tab_' + groupType"
                    :active="index === 0"
                >
                    <template #title>
                        {{ __t('TG_NOTIF.' + groupType.toUpperCase()) }}
                    </template>

                    <div class="list-group">
                        <div
                            v-for="group in items"
                            :key="'notif_' + group.id"
                            class="list-group-item d-flex align-items-center justify-content-between"
                        >
                            <div>
                                <div class="fw-600">
                                    {{ __t(group.user_name)  }}
                                </div>

                                <small class="text-muted">
                                    {{ group.type }}
                                </small>
                            </div>

                            <div class="custom-control custom-switch">
                                <input
                                    :id="'tg-notif-' + group.id"
                                    type="checkbox"
                                    class="custom-control-input"
                                    :checked="isNotificationEnabled(group.id)"
                                    @change="toggleNotification(group.id, $event.target.checked)"
                                >

                                <label
                                    class="custom-control-label"
                                    :for="'tg-notif-' + group.id">
                                </label>
                            </div>
                        </div>
                    </div>
                </b-tab>
            </b-tabs>

        </div>
    </div>
</template>

<script>
import yes_no from "../../../../sys/radio/yes_no.vue";
import Info_field from "../../../../sys/info_field.vue";

export default {
    name: "tg_info",
    components: {yes_no, Info_field},

    props : {
        role_item : {
            type : Object
        }
    },

    created() {
        this.cur_item = this.role_item;
        this.loadNotificationGroups();

        if(!this.cur_item.hasOwnProperty('tg_user')) {
            this.is_set_data = true;
        }

    },

    data() {
        return {
            cur_item : {
                provider_id : 0,
                attached_notification: [],
            },

            is_load: false,
            notification_groups : [],
            is_set_data : false,
        }
    },

    computed: {

        attachedNotificationIds() {
            return (this.cur_item?.attached_notification || [])
                .map(item => parseInt(item.group_id));
        },

        groupedNotificationGroups() {
            let groups = {};

            (this.notification_groups || []).forEach(item => {
                let groupType = item.group_type || 'other';

                if (!groups[groupType]) {
                    groups[groupType] = [];
                }

                groups[groupType].push(item);
            });

            return groups;
        },
    },

    methods : {
        async loadNotificationGroups() {
            this.notification_groups = [];
            this.is_load = true;

            await api.get('/internal/v1/roles/telegram/notification/groups')
                .then(({data}) => {
                    this.is_load = false;
                    this.notification_groups = data.data || [];
                })
                .catch(({response}) => {
                    this.is_load = false;

                    EventBus.$emit('show_toast', {
                        err: response.data.message,
                        type: "danger",
                        title: response.data.status,
                        position: "b-toaster-top-left"
                    });
                });
        },

        isNotificationEnabled(groupId) {
            return this.attachedNotificationIds.includes(parseInt(groupId));
        },

        toggleNotification(groupId, checked) {
            groupId = parseInt(groupId);

            let attached = this.cur_item.attached_notification || [];

            if (checked) {
                let exists = attached.some(item => parseInt(item.group_id) === groupId);

                if (!exists) {
                    let group = this.notification_groups.find(item => parseInt(item.id) === groupId);

                    attached.push({
                        id: 0,
                        uuid: this.cur_item.user_uid,
                        group_id: groupId,
                        group: group || null,
                    });
                }
            } else {
                attached = attached.filter(item => parseInt(item.group_id) !== groupId);
            }

            this.$set(this.cur_item, 'attached_notification', attached);
            this.$emit('on_change_attribute', 'attached_notification', attached);
        },

        change_atr(atr_name,atr_val) {
            this.$set(this.cur_item, atr_name, atr_val);
            this.$emit('on_change_attribute', atr_name, atr_val);
        }

    }
}
</script>



<style scoped>

</style>
